var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"block toc"},[_c('h2',[_vm._v("Table of Contents")]),_vm._v(" "),_c('nav',{staticClass:"toc-list"},[_c('ul',_vm._l((_vm.links),function(link){return _c('li',{key:link.id,class:`toc-link-${link.depth}`},[_c('a',{attrs:{"href":`#${link.id}`}},[_vm._v(_vm._s(link.text))])])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }